import React from 'react';
import {Field} from 'redux-form';
import {Platform, View} from 'react-native';

import {BaseField} from '../../../shared/components/baseField';
import {DeviceSize} from '../../../shared/theme/helpers';
import {useStyles} from '../../../shared/hooks/styles';
import {useIsDesktop} from '../../../shared/hooks/useIsDesktop';

const formWidthDesktop = 374;

export const PasswordFields = ({onSubmit}: {onSubmit: (e?: any) => void}) => {
  const isDesktop = useIsDesktop();
  const styles = useStyles(({mediaOnly}) => {
    return {
      fieldContainer: {
        position: 'relative',
        ...mediaOnly(DeviceSize.desktop, {}, {marginTop: 0, width: '100%'}),
      },
      fieldContainerWithMargin: {
        marginBottom: 20,
      },
    };
  });

  return (
    <>
      <View style={[styles.fieldContainer, Platform.OS === 'web' ? styles.fieldContainerWithMargin : null]}>
        <Field
          component={BaseField}
          label='Новый пароль'
          type='password'
          name='password'
          onSubmitEditing={onSubmit}
          style={isDesktop ? {width: formWidthDesktop} : undefined}
        />
      </View>
      <View style={styles.fieldContainer}>
        <Field
          component={BaseField}
          label='Повторите пароль'
          type='password'
          name='confirm'
          onSubmitEditing={onSubmit}
          style={isDesktop ? {width: formWidthDesktop} : undefined}
        />
      </View>
    </>
  );
};
